import React from "react";
import "./Ticket.css";

export default function Ticket({ variant = "primary", punched = false, header, stub, children }) {
  const className = [
    "trunfo-ticket",
    `trunfo-ticket--${variant}`,
    punched ? "trunfo-ticket--punched" : null,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <article className={className}>
      {header && <header className="trunfo-ticket__header">{header}</header>}
      <div className="trunfo-ticket__body">{children}</div>
      {stub && (
        <>
          <div className="trunfo-ticket__perforation" aria-hidden="true" />
          <aside className="trunfo-ticket__stub">{stub}</aside>
        </>
      )}
    </article>
  );
}
